// Utilities
import { make } from 'vuex-pathify'

const state = {
  categories: [],
  filter: 'All',
  picture: null,
  pictures: [],
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations,
}
